import { SMART_RESIZE_RETRY_SUGGESTIONS } from '../constants';

export const buildImprovementNotes = (selectedSuggestionIds: string[], detail: string): string[] => {
  const trimmedDetail = detail.trim();

  if (!trimmedDetail) {
    return [];
  }

  const chipNotes = SMART_RESIZE_RETRY_SUGGESTIONS.filter((suggestion) =>
    selectedSuggestionIds.includes(suggestion.id),
  ).map((suggestion) => suggestion.label);

  return [...chipNotes, trimmedDetail];
};

export const formatSmartResizeRetryChatMessage = (selectedSuggestionIds: string[], detail: string): string => {
  const trimmedDetail = detail.trim();
  const chipNotes = SMART_RESIZE_RETRY_SUGGESTIONS.filter((suggestion) =>
    selectedSuggestionIds.includes(suggestion.id),
  ).map((suggestion) => suggestion.label);

  const lines = ['Retrying this resize with your notes:'];

  for (const note of chipNotes) {
    lines.push(`- ${note}`);
  }

  if (trimmedDetail) {
    lines.push(trimmedDetail);
  }

  return lines.join('\n');
};
